const CHECKLIST_NUMBER_PREFIX_PATTERN = /^\s*\d+(?:[.,]\d+)*[.)]?\s+/;

export function stripLeadingChecklistNumber(summary: string): string {
  return summary.replace(CHECKLIST_NUMBER_PREFIX_PATTERN, '');
}